import React, { useEffect, useState } from "react";
import "./PortfolioPage.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";
import { getPortfolios } from "../features/dataSlice";
import { css } from "@emotion/core";
import RingLoader from "react-spinners/RingLoader";
import { Flipper, Flipped } from "react-flip-toolkit";
import { useHistory } from "react-router-dom";

const override = css`
  display: block;
  margin: 0 auto;
  margin-left: -10%;
  border-color: red;
`;

const shouldFlip = (id) => (prevDecisionData, currentDecisionData) =>
  id === prevDecisionData || id === currentDecisionData;

const ListItem = ({ id, changeFocus, portfolio }) => {
  return (
    <Flipped
      flipId={`listItem-${id}`}
      shouldInvert={shouldFlip(id)}
      stagger="card"
    >
      <div className="listItem" onClick={() => changeFocus(id)}>
        <Flipped inverseFlipId={`listItem-${id}`}>
          <div className="listItemContent">
            <Flipped
              flipId={`avatar-${id}`}
              stagger="card-content"
              shouldFlip={shouldFlip(id)}
            >
              <img
                loading="lazy"
                className="avatar"
                src={portfolio.imageURL1}
              />
            </Flipped>
            <div className="description">
              <Flipped
                flipId={`description-${id}-${1}`}
                key={1}
                stagger="card-content"
                shouldFlip={shouldFlip(id)}
              >
                <h1 className="h1" key={1}>
                  {portfolio.name}
                </h1>
              </Flipped>
              <Flipped
                flipId={`description-${id}-${2}`}
                key={2}
                stagger="card-content"
                shouldFlip={shouldFlip(id)}
              >
                <h2 key={2}>{portfolio.category}</h2>
              </Flipped>
              <Flipped
                flipId={`description-${id}-${3}`}
                key={3}
                stagger="card-content"
                shouldFlip={shouldFlip(id)}
              >
                <h3 key={3}>{portfolio.language}</h3>
              </Flipped>
            </div>
          </div>
        </Flipped>
      </div>
    </Flipped>
  );
};

const ExpandedListItem = ({ id, changeFocus, portfolio }) => {
  const history = useHistory();
  return (
    <Flipped
      flipId={`listItem-${id}`}
      stagger="card"
      onStart={(el) => {
        setTimeout(() => {
          el.classList.add("animated-in");
        }, 600);
      }}
    >
      <div className="expandedListItem" onClick={() => changeFocus(id)}>
        <Flipped inverseFlipId={`listItem-${id}`}>
          <div className="expandedListItemContent">
            <Flipped flipId={`avatar-${id}`} stagger="card-content">
              <img
                loading="lazy"
                src={portfolio.imageURL1}
                className="avatar avatarExpanded"
              />
            </Flipped>
            <div className="description">
              <Flipped
                flipId={`description-${id}-${1}`}
                key={1}
                stagger="card-content"
                shouldFlip={shouldFlip(id)}
              >
                <h1 style={{ fontSize: "26px", fontWeight: 700 }} key={1}>
                  Name: <span className="h1">{portfolio.name}</span>
                </h1>
              </Flipped>
              <Flipped
                flipId={`description-${id}-${2}`}
                key={2}
                stagger="card-content"
                shouldFlip={shouldFlip(id)}
              >
                <h2 key={2}>Category: {portfolio.category}</h2>
              </Flipped>
              <Flipped
                flipId={`description-${id}-${3}`}
                key={3}
                stagger="card-content"
                shouldFlip={shouldFlip(id)}
              >
                <h3 key={3}>Language: {portfolio.language}</h3>
              </Flipped>
            </div>
            <div className="additional-content">
              <button
                className="button-one"
                key={1}
                onClick={() => history.push(`/projects/${id}`)}
              >
                See more
              </button>
              <a href={portfolio.url} target="_blank">
                <button className="button-two" key={2}>
                  Visit site
                </button>
              </a>
            </div>
          </div>
        </Flipped>
      </div>
    </Flipped>
  );
};

const PortfolioPage = () => {
  const portfolios = useSelector(getPortfolios);
  const [focused, setFocused] = useState(null);

  useEffect(() => {
    document.title = "Ashwin's Portfolio - Projects";
    return () => {
      //
    };
  }, []);

  const changeFocus = (id) => {
    setFocused(focused === id ? null : id);
  };

  return (
    <div className="portfolios">
      <Header />
      {portfolios.length !== 0 ? (
        <div className="portfolios-body">
          <Flipper
            flipKey={focused}
            className="staggered-list-content"
            spring="gentle"
            staggerConfig={{
              card: {
                reverse: focused !== null,
                speed: 0.5,
              },
            }}
            decisionData={focused}
          >
            <ul className="list">
              {portfolios.map((portfolio) => (
                <li key={portfolio.id}>
                  {portfolio.id === focused ? (
                    <ExpandedListItem
                      id={portfolio.id}
                      changeFocus={changeFocus}
                      portfolio={portfolio}
                    />
                  ) : (
                    <ListItem
                      id={portfolio.id}
                      key={portfolio.id}
                      changeFocus={changeFocus}
                      portfolio={portfolio}
                    />
                  )}
                </li>
              ))}
            </ul>
          </Flipper>
        </div>
      ) : (
        <div className="sweet-loading">
          <RingLoader
            color={"#17D0D3"}
            loading={portfolios.length === 0}
            css={override}
            size={150}
          />
        </div>
      )}
      <Footer />
    </div>
  );
};

export default PortfolioPage;
